import React from "react";
import TransferirDocumentosForm from "../v2/invite/components/TransferirDocumentosForm";

const TransferirDocumentos = () => <TransferirDocumentosForm />;

export default TransferirDocumentos;
